
const validateRequired = (value) => {
	return value ? undefined : 'This field is required';
}

const validateMin = (value, min) => {
	return value.length >= min ? undefined : `Minimum length is ${min}`;
}

const validateMax = (value, max) => {
	return value.length <= max ? undefined : `Maximum length is ${max}`;
}

const validateEmail = (value) => {
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return emailPattern.test(value) ? undefined : 'Invalid email address';
}

const validatePassword = (value) => {
	// password min 8 chart and at least one letter and one number
	const passwordPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
	return passwordPattern.test(value) ? undefined : 'Password must be at least 8 characters long and contain at least one letter and one number';
}

const validateConfirmPassword = (value, password) => {
	return value === password ? undefined : 'Passwords do not match';
}

const validateAge = (value) => {
	const date = new Date(value);
	const today = new Date();
	let age = today.getFullYear() - date.getFullYear();
	const monthDiff = today.getMonth() - date.getMonth();
	if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
		age--;
	}
	return age >= 18 ? undefined : 'You must be at least 18 years old';
}

const ruleMap = {
	required: validateRequired,
	min: validateMin,
	max: validateMax,
	email: validateEmail,
	password: validatePassword,
	confirm_password: validateConfirmPassword,
	age: validateAge,
};

const validateFiled = (field, value, rules) => {
	const errors = rules.map((rule) => {
		const [ruleName, ...params] = rule.split(':');
		const validator = ruleMap[ruleName];
		if (validator) {
			return validator(value, ...params);
		}
		return undefined;
	}).filter(error => error !== undefined);

	return errors.length > 0 ? errors : undefined;
  }
  
export { validateFiled };